import { apiUrl } from '../../../../../constants/global';
import axios from 'axios';
import { getLoggedUser } from '../../../../../state/user';

const user = getLoggedUser();
const endpoint = apiUrl + 'v2';

async function getSiteVisitRequest(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/site-visit-forms?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliverySiteList(filters) {
  const query = new URLSearchParams(filters).toString();

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/delivery-sites?${query}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

async function getDeliverySite(id) {

  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };

  try {
    const { data: response } = await axios.get(`${endpoint}/delivery-sites/${id}`, config);
    return response;
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: error.response?.data?.message || 'Something went wrong',
      status: error.response?.status || 500,
      error: error,
    };
  }
}

export const updateDeliverySite = async (id, data) => {
  try {
    const response = await axios.put(`${endpoint}/delivery-sites/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + user.token,
      },
    });
    return response;
  } catch (error) {
    console.error('API Error:', error);
    if (error.response) {
      return error.response;
    }
    throw error;
  }
};


// Update this function to accept format parameter
export const getOverallCollectionSummary = async (deliverySiteId, format = null) => {
  try {
    // Build URL with query params
    let url = `${endpoint}/delivery-sites/${deliverySiteId}/overall-summary`;
    
    // Add format parameter if provided
    if (format) {
      url += `?format=${format}`;
    }
    
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + user.token,
      },
      // Important: Set responseType to 'blob' for Excel download
      responseType: format === 'excel' ? 'blob' : 'json'
    });
    
    return response.data;
  } catch (error) {
    console.error('Error fetching overall collection summary:', error);
    throw error;
  }
};


export { getSiteVisitRequest, getDeliverySiteList, getDeliverySite };
